export enum GAEvent {
    PageView = 'pageview',
    Custom = 'customEvent',
}
